import { Box, Button, Checkbox, CircularProgress, Divider, FormControl, FormControlLabel, Grid, InputLabel, MenuItem, Select, TextField, Typography } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { toast } from 'react-toastify'
import apiClient from '../../utils/apiClient'

const AddEditTaxConfig = () => {
    const location = useLocation()
    const taxConfig = location?.state?.taxConfig || ''

    const [formData, setFormData] = useState({
        id: "",
        name: "",
        description: '',
        feeType: "",
        type: "",
        value: "",
        isActive: true,


    })

    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);
    const [validateErrors, setValidateErrors] = useState({})
    const navigate = useNavigate()

    useEffect(() => {
        if (taxConfig) {
            setFormData(taxConfig)
        }
    }, [taxConfig])

    const handleInputChange = (e) => {
        const { name, value } = e.target;


        setFormData(prev => ({ ...prev, [name]: value }));
        setValidateErrors(prev => ({ ...prev, [name]: '' }));


        setError('');
    };

    const handleCheckboxChange = (e) => {
        const { name, checked } = e.target;
        setFormData((prev) => ({
            ...prev,
            [name]: checked,
        }));
    };

    const validateForm = () => {
        const errors = {};
        if (!formData.name) {
            errors.name = 'Name is required';
        }
        if (!formData.description) {
            errors.description = 'Description is required';
        }
        if (!formData.feeType) {
            errors.feeType = 'Fee type is required';
        }
        if (!formData.type) {
            errors.type = 'Type is required';
        }
        if (!formData.value) {
            errors.value = 'value is required';
        }
        return errors;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const errors = validateForm();
        if (Object.keys(errors).length > 0) {
            setValidateErrors(errors);
            return
        }
        setLoading(true)
        try {
            const response = taxConfig.id
                ? await apiClient.put(`/extrafee/admin/extrafees/${taxConfig.id}`, formData)
                : await apiClient.post(`/extrafee/admin/extrafees`, formData);

            if (response?.data?.status === true) {
                toast.success(response?.data?.message || 'Tax create/update successfully')
                navigate(-1)
            }

        } catch (error) {
            setError(error?.response?.data?.message || 'Something went to be worng')
        }
        finally {
            setLoading(false)

        }
    }



    return (
        <>
            <Box sx={{ backgroundColor: '', padding: 3 }}>
                <Typography variant="h4" sx={{ mb: 3 }}>
                    {taxConfig.id ? " Edit Tax Config" : "Add Tax Config"}
                </Typography>
                <Divider sx={{ marginBottom: 3 }} />

                <form onSubmit={handleSubmit}>
                    <Grid container spacing={2}>
                        {/* Name */}
                        <Grid item size={{ xs: 12, sm: 6 }}>
                            <TextField
                                label="Name"
                                name="name"
                                fullWidth
                                size="small"
                                value={formData.name}
                                onChange={handleInputChange}
                                error={!!validateErrors.name}
                                helperText={validateErrors.name}
                            />
                        </Grid>

                        {/* Description */}
                        <Grid item size={{ xs: 12, sm: 6 }}>
                            <TextField
                                label="Description"
                                name="description"
                                fullWidth
                                size="small"
                                value={formData.description}
                                onChange={handleInputChange}
                                error={!!validateErrors.description}
                                helperText={validateErrors.description}
                            />
                        </Grid>

                        {/* Fee Type */}
                        <Grid item size={{ xs: 12, sm: 6 }}>
                            <TextField
                                label="Fee Type (GST)"
                                name="feeType"
                                fullWidth
                                size="small"
                                value={formData.feeType}
                                onChange={handleInputChange}
                                error={!!validateErrors.feeType}
                                helperText={validateErrors.feeType}
                            />
                        </Grid>

                        {/* Type */}
                        <Grid item size={{ xs: 12, sm: 6 }}>
                            <FormControl fullWidth size='small'>
                                <InputLabel id="status-label">Type</InputLabel>
                                <Select
                                    labelId="status-label"
                                    id="status-select"
                                    value={formData.type}
                                    label="Type"
                                    name='type'
                                    onChange={handleInputChange}
                                >
                                    <MenuItem value="percentage">Percentage</MenuItem>
                                    <MenuItem value="amount">Amount</MenuItem>
                                </Select>
                            </FormControl>
                        </Grid>

                        {/* Value */}
                        <Grid item size={{ xs: 12, sm: 6 }}>
                            <TextField
                                label="Value"
                                name="value"
                                fullWidth
                                size="small"
                                type="number"
                                value={formData.value}
                                onChange={handleInputChange}
                                error={!!validateErrors.value}
                                helperText={validateErrors.value}
                            />
                        </Grid>

                        {/* Is Active Checkbox */}
                        <Grid item size={12}>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        name="isActive"
                                        checked={formData.isActive}
                                        onChange={handleCheckboxChange}
                                        size="small"
                                    />
                                }
                                label="Is Active"
                            />
                        </Grid>

                        {/* Error Message */}
                        {error && (
                            <Grid item size={12}>
                                <Typography color="error">{error}</Typography>
                            </Grid>
                        )}

                        {/* Submit Buttons */}
                        <Grid item size={12}>
                            <Box display="flex" justifyContent="end" mt={2} gap={2}>
                                <Button variant="outlined" color="primary" onClick={() => navigate(-1)}>
                                    Cancel
                                </Button>
                                <Button type="submit" variant="contained" disabled={loading}>
                                    {loading ? (
                                        <CircularProgress size={24} sx={{ color: '#fff' }} />
                                    ) : (
                                        taxConfig.id ? 'Update' : 'Create'
                                    )}
                                </Button>
                            </Box>
                        </Grid>
                    </Grid>
                </form>

            </Box>
        </>
    )
}

export default AddEditTaxConfig
